import { Breadcrumb } from '@shared/breadcrumbs/Breadcrumb';
import { BreadcrumbItem } from '@shared/breadcrumbs/BreadcrumbItem';

const dashboard = new BreadcrumbItem('core.breadcrumb.dashboard', { name: 'dashboard' });

const default_dashboard = new Breadcrumb('default', [dashboard]);

const core_items = ['profile', 'payment.index', 'price.index'];

const top_level_breadcrumbs = core_items.map(item => {
  return default_dashboard.extend(`core.${item}`).add(`core.breadcrumb.${item}`, {
    name: `core.${item}`
  });
});
const document = default_dashboard
  .extend('core.document.index')
  .add('core.breadcrumb.document.index', {
    name: 'core.document.index'
  });

const create_document = document
  .extend('core.document.create')
  .add('core.breadcrumb.document.create', {
    name: 'core.document.create'
  });

const prices_breadcrumbs = ['core.price.type'].map(item => {
  return default_dashboard.extend(item).add(`core.breadcrumb.price.index`, {
    name: `core.price.index`
  });
});

const document_breadcrumbs = [document, create_document];

const core_breadcrumbs = [...top_level_breadcrumbs, ...prices_breadcrumbs, ...document_breadcrumbs];

export { default_dashboard, core_breadcrumbs };
